const IN_VIEW_CLASS = 'section-is-in-view';
import { gsap, ScrollTrigger } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger);

class SectionTriggers {
  constructor() {
    this.elements = document.querySelectorAll('.js-page-section');
    this.body = document.documentElement;
    // this.circleOpacity;
    // this.circleSize;
    // this.circleSizeValue;
    this.frame = document.querySelector('.js-frame');
    this.items = gsap.utils.toArray('.about__pair');
    this.headings = document.querySelectorAll('.page-section--work');
    this.themeBG;
    this.themeText;
    this.themeSpot;
    this.gradientStart;
    this.gradientEnd;
    this.backgroundBlur;
    this.cursorBG;
    this.frameWidth;
    this.frameHeight;
    this.frameBorder;

    this.handleIntersection();
  }

  handleIntersection() {
    this.elements.forEach(entry => {
      const entryInner = entry.querySelector('.title-opacity-in');
      const tl = gsap.timeline();

      if (window.innerWidth > 768) {
        if (entryInner) {
          tl.from(entryInner, {
            duration: 1,
            opacity: 0,
            ease: 'power2.in',
            filter: 'blur(7px)',
          }).to(entryInner, {
            duration: 1,
            delay: -1,
            opacity: 1,
            ease: 'power2.in',
            filter: 'blur(0px)',
          });
        }
      }

      ScrollTrigger.create({
        trigger: entryInner,
        start: 'top bottom',
        end: 'top center',
        scrub: true,
        animation: tl,
      });

      ScrollTrigger.create({
        trigger: entry,
        start: 'top center',
        end: 'bottom center',
        onToggle: () => {
          const currentBucket = document.querySelector(
            `[data-bucket-id="${entry.dataset.sectionId}"]`,
          );

          document.querySelectorAll('.frame__asset-bucket').forEach(entry => {
            entry.classList.remove('bucket-is-active');
          });

          this.elements.forEach(entry => {
            entry.classList.remove(IN_VIEW_CLASS);
          });

          entry.classList.add(IN_VIEW_CLASS);

          if (currentBucket) {
            currentBucket.classList.add('bucket-is-active');
          }

          const themeBG = entry.dataset['bgColor'];

          this.themeBG = themeBG;
          this.themeText = entry.dataset['textColor'];
          this.themeSpot = entry.dataset['spotColor'];
          this.gradientStart = entry.dataset['gradientStart'];
          this.gradientEnd = entry.dataset['gradientEnd'];
          this.backgroundBlur = entry.dataset['bgBlur'];
          this.cursorBG = entry.dataset['cursorBg'];
          this.frameWidth = entry.dataset['frameWidth'];
          this.frameHeight = entry.dataset['frameHeight'];
          this.frameBorder = entry.dataset['frameBorderColor'];
          // this.circleSize = entry.dataset['circleSize'];
          // const circleSizes = {
          //   button: `200px`,
          //   small: `500px`,
          //   large: `105vw`,
          // };

          // this.circleSizeValue = circleSizes[this.circleSize];

          // this.circleOpacity = this.themeBG === '#000000' ? `1` : `0.4`;

          if (window.innerWidth > 768) {
            gsap.to(this.body, {
              duration: 1.5,
              ease: 'power3.out',
              css: {
                // '--circle-opacity': this.circleOpacity,
                // '--circle-size': this.circleSizeValue,
                '--frame-width': this.frameWidth,
                '--frame-height': this.frameHeight,
              },
            });
          }

          gsap.to(this.body, {
            duration: 0.75,
            ease: 'power3.out',
            css: {
              '--c-bg': this.themeBG,
              '--c-text': this.themeText,
              '--c-spot': this.themeSpot,
              '--gradient-start': this.gradientStart,
              '--gradient-end': this.gradientEnd,
              '--bg-blur': this.backgroundBlur,
              '--c-cursor-bg': this.cursorBG,
              '--c-border-color': this.frameBorder,
            },
          });
        },
      });
    });
  }
}

export default SectionTriggers;
